import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import TableBodyCheckbox from '../../../../components/Table/BodyCheck';

import { generateTableBody } from '../../helpers';

const Body = ({ items, access, setConfirmValues, toggleConfirm, values, onChangeCheck }) => {
  const onDeleteUpdate = (id) => {
    setConfirmValues({ id, title: 'single' });
    toggleConfirm();
  };

  return (
    <tbody>
      {items?.map((item) => (
        <tr key={item.id}>
          {generateTableBody(item, access).map((elem, idx) => {
            switch (elem.type) {
            case 'checkbox':
              return (
                <TableBodyCheckbox
                  key={idx}
                  disabled={false}
                  item={item}
                  values={values}
                  onChangeCheck={onChangeCheck}
                  tdClass="check"
                />
              );

            case 'service':
              return (
                <td key={idx} className="service">
                  <span className="service__id">{item.service_id}</span>
                  {elem.value}
                </td>
              );

            case 'delete':
              return (
                <td key={idx} className="action">
                  <Button bsSize="xsmall" className="delete-action" onClick={() => onDeleteUpdate(item.id)}>Delete</Button>
                </td>
              );

            default:
              return <td key={idx}>{elem.value}</td>;
            }
          })}
        </tr>
      ))}
    </tbody>
  );
}

Body.propTypes = {
  access: PropTypes.object,
  items: PropTypes.array,
  setConfirmValues: PropTypes.func,
  toggleConfirm: PropTypes.func,
  values: PropTypes.array,
  onChangeCheck: PropTypes.func,
};

export default Body;
